import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import HelperFilesModal from "../../shared/component/helper_files_modal";
import styled from "styled-components";
import { TabContainer } from "./style";
import { Flex } from "../../shared/styled/flex";
import OptionSelectorSwitch from "../../shared/controls/option-selector-switch";
import OrdersSummaryList from "../../control/orders/orders-summary-list";
import { cancelRequest, createEntity, getEntityItems, readEntities, readEntity } from "../../redux/api";
import { View } from "../../shared/styled/view";
import Loader from '../../shared/icons/tat/loader';
import Button from "../../shared/controls/button";
import CreateOrderModal from "../../control/orders/create-order-modal";
import { downloadPermissionFile, loadSession } from "../../redux/reducers/global-catalog.reducer";
import { cancelMultipleRequests } from "../../redux/api/actions";
import { getCurrentCommandTabSelected, sendMessageToMultipleUsersInSocket, setCurrentCommandTabSelected, showSimpleFlashNotification } from "../../shared/utils";
import GenericDialog from "../../shared/dialog/generic-modal";
import moment from 'moment';
import FilterBarCompact from "../../shared/component/filter/filter-bar-compact";
import { cloneDeep } from "lodash";

const ITEMS = [
  { description: "FTL", value: 1 },
  { description: "LTL", value: 2 },
]

const TRANSACTIONS = [
  { description: "Compra", value: 1 },
  { description: "Venta", value: 2 },
  // { description: "Todo", value: 4 },
]

class HomeCoView extends React.Component {

  state = {
    tab_selected: 1,
    second_tab_selected: 1,
    third_tab_selected: 1,
    showCreateOrderModal: false,

    productsToAdd: [],
    selectedProvider: 0,
    selectedFacility: 0,
    selectedTags: [],
    selectedCode: "",

    facilityCatalog: [],
    selectedDestiny: null,
    providerProducts: [],
    moreProducts: true,
    selectedDate: null,
    error_message: null,
    tabSelectedByMenu : '',
    providerFacilities: [],
    searchStr: '',
    searchStr2: '', 
    emails: [],
    selectedClient: null,
    requisitionsResume: [],
    requisitionsResumeCounter: 0,
    ordersResume: [],
    ordersResumeCounter: 0,
    tripsResume: [],
    tripsResumeCounter: 0,
    trTripsResume: [],
    trTripsResumeCounter: 0
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.cancelUpdate, true);
  }

  componentDidMount() {

    if (this.props.isCOWH) {
      this.initData();
    } else {
      this.setState({
        tab_selected: 5
      }, () => {
        this.initData();
      });
    }

  }

  componentDidUpdate(prepProps) {
    
    if (this.props.location.search.includes('tab')) {
      const query = new URLSearchParams(this.props.location.search);
      const current_tab = query.get('tab');

      if (current_tab !== this.state.tabSelectedByMenu) {
        this.setState({
          tabSelectedByMenu: query.get('tab'),
          tab_selected: current_tab === 'ordenes' ? 3 : 1
        }, () => {
          this.loadItems();
        });
      }
    } else {
      if (this.state.tabSelectedByMenu !== '') {
        this.setState({
          tabSelectedByMenu: '',
          tab_selected: 1
        }, () => {
          this.loadItems();
        });
      }
    }

  }

  setTabs = () => {
    if (!this.props.isCOWH || this.props.location.search.includes('tab')) { return; } 

    let current_tab = getCurrentCommandTabSelected();

    if (current_tab) {
      this.state.tab_selected = current_tab.main_tab;
      this.state.second_tab_selected = current_tab.second_tab;
      this.state.third_tab_selected = current_tab.third_tab || 1;
    }
  }

  initData = () => {

    this.setTabs();

    document.addEventListener("keydown", this.cancelUpdate);
    this.loadItems();

    this.props.loadCompanyUnits({
      company_id: this.props.companyId,
    });
    this.props.loadCompanyProviders({
      company_id: this.props.companyId,
    });
  }

  loadProviderFacilities = () => {
    if (this.state.selectedProvider === '-1') {
      return
    }

    this.props.loadProviderFacilities({
      company_id: this.props.companyId,
      network_id: this.state.selectedProvider
    }, {
      onSuccess: (response) => {

        let tags = Object.entries(response);
        let all_facilities_group = [];

        tags.map( item => {

          if (item.length > 1) {

            let item_to_add = {
              label: `${item[0]}` === 'null' ? 'Sin tag' : item[0]
            }
            let facilities = [];

            (item[1] || []).map( item_2 => {
              facilities.push({
                value: `${item_2.id}`,
                id: item_2.id,
                label: `${item_2.name} - ${item_2.alias} - ${item_2.code}`
              });

            });

            item_to_add.options = facilities;
            all_facilities_group.push(item_to_add);
          }

        });

        this.setState({
          providerFacilities: all_facilities_group
        });
      }
    });
  }

  loadProviderProducts = (search_value, offset) => {
    if (this.state.selectedProvider === '-1') {
      this.props.loadProducts({
        company_id: this.props.companyId,
        view: 'short_detail',
        tags: '',
        skus: '',
        products: '',
        search: search_value || '',
        limit: '',
        offset: offset || '',
        isMultipleCancels: true
      }, {
        onSuccess: (response) => {
          this.setState({
            moreProducts: `${offset}` === '1' ? true : response.length > 0,
            providerProducts: `${offset}` === '1' ? response : this.state.providerProducts.concat(response)
          })
        }
      });
      return
    }

    this.props.loadProviderProducts({
      company_id: this.props.companyId,
      network_id: this.state.selectedProvider,
      search: search_value || '',
      offset: offset || '',
      isMultipleCancels: true
    }, {
      onSuccess: (response) => {
        this.setState({
          moreProducts: `${offset}` === '1' ? true : response.length > 0,
          providerProducts: `${offset}` === '1' ? response : this.state.providerProducts.concat(response)
        })
      }
    });
  }

  cancelUpdate = (e) => {
    if(e.key === "Escape" && this.props.isLoading){
      this.props.cancelRequest("COMPANIES.REQUISITIONSCONTROL.ORDERS.RESUME");
      this.props.cancelRequest("COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUME");
      this.props.cancelRequest("COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUMETR");
      this.props.cancelRequest("COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.RESUME");
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'second_tab_selected') {
      setCurrentCommandTabSelected(null, value, null);
      this.state.searchStr = '';
    }

    if (name === 'third_tab_selected') {
      setCurrentCommandTabSelected(null, null, value);
    }

    this.setState({ [name]: value });
  }

  setResumeInfo = () => {
    
  }

  loadItems = () => { 
    this.props.cancelRequest("COMPANIES.REQUISITIONSCONTROL.ORDERS.RESUME");
    this.props.cancelRequest("COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUME");
    this.props.cancelRequest("COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.RESUME");
    this.props.cancelRequest("COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUMETR");

    let codes = this.state.emails.map( item => item.email);

    switch(this.state.tab_selected){
      case 1:
        this.props.loadCompanyRequisitionsResume({
          company_id: this.props.companyId,
          requisition_codes: codes
        }, {
          onSuccess: (response) => {

            let tags = Object.entries(response['data'] || {});
            let all_facilities_group = [];
            let all_facilities = [];

            tags.map( item => {

              if (item.length > 1) {

                let item_to_add = {
                  label: `${item[0]}` === 'null' ? 'Sin tag' : item[0]
                }
                let facilities = [];

                (item[1] || []).map( item_2 => {
                  facilities.push({
                    value: `${item_2.id}`,
                    id: item_2.id,
                    label: `${item_2.name} - ${item_2.alias} - ${item_2.code}`
                  });

                  if (!all_facilities.includes(item_2.id)) {
                    all_facilities.push(item_2.id);
                  }

                });

                item_to_add.options = facilities;
                all_facilities_group.push(item_to_add);
              }

            });

            if (codes.length > 0) {

              let has_requisitions = false;
              let counter_list = Object.entries(response['counter']);

              (counter_list || []).map( item => {
                if (item[1]['1'] > 0 || item[1]['2'] > 0 || item[1]['3'] > 0 || item[1]['4'] > 0) {
                  has_requisitions = true;
                }
              });

              if (has_requisitions) {

                this.props.history.push(
                  `/company/controls/requisitions/?facilities=${all_facilities}&codes=${codes}`, {
                    transactionType: this.state.second_tab_selected !== 4 ? this.state.second_tab_selected : null, 
                  }
                );

              } else {

                this.setState({
                  error_message: 'Pedidos no encontrados'
                });
              }

            } else {

              this.setState({
                facilityCatalog: all_facilities_group,
                requisitionsResume: Object.entries(response['data']),
                requisitionsResumeCounter: response['counter']
              });

            }

          }

        });
      break;
      case 2:
        this.props.loadCompanyOrdersResume({
          company_id: this.props.companyId,
          order_codes: codes
        }, {
          onSuccess: (response) => {

            let tags = Object.entries(response['data'] || {});
            let all_facilities_group = [];
            let all_facilities = [];

            tags.map( item => {

              if (item.length > 1) {

                let item_to_add = {
                  label: `${item[0]}` === 'null' ? 'Sin tag' : item[0]
                }
                let facilities = [];

                (item[1] || []).map( item_2 => {
                  facilities.push({
                    value: `${item_2.id}`,
                    id: item_2.id,
                    label: `${item_2.name} - ${item_2.alias} - ${item_2.code}`
                  });

                  if (!all_facilities.includes(item_2.id)) {
                    all_facilities.push(item_2.id);
                  }

                });

                item_to_add.options = facilities;
                all_facilities_group.push(item_to_add);
              }

            });

            if (codes.length > 0) {

              let has_requisitions = false;
              let counter_list = Object.entries(response['counter']);

              (counter_list || []).map( item => {
                if (item[1]['1'] > 0 || item[1]['2'] > 0 || item[1]['3'] > 0 || item[1]['4'] > 0 || item[1]['5'] > 0 || item[1]['6'] > 0 || item[1]['7'] > 0 || item[1]['8'] > 0 || item[1]['9'] > 0 || item[1]['10'] > 0 || item[1]['11'] > 0 || item[1]['12'] > 0) {
                  has_requisitions = true;
                }
              });

              if (has_requisitions) {

                this.props.history.push(
                  `/company/controls/requisitionorders/?facilities=${all_facilities}&codes=${codes}`, {
                    transactionType: this.state.second_tab_selected !== 4 ? this.state.second_tab_selected : null, 
                  }
                );

              } else {

                this.setState({
                  error_message: 'Órdenes no encontradas'
                });
              }

            } else {

              this.setState({
                facilityCatalog: all_facilities_group,
                ordersResume: Object.entries(response['data']),
                ordersResumeCounter: response['counter']
              });

            }
            
          }

        })
      break;
      case 3:
        this.props.loadCompanyOrdersResume({
          company_id: this.props.companyId,
          order_codes: codes
        }, {
          onSuccess: (response) => {

            let tags = Object.entries(response['data'] || {});
            let all_facilities_group = [];
            let all_facilities = [];

            tags.map( item => {

              if (item.length > 1) {

                let item_to_add = {
                  label: `${item[0]}` === 'null' ? 'Sin tag' : item[0]
                }
                let facilities = [];

                (item[1] || []).map( item_2 => {
                  facilities.push({
                    value: `${item_2.id}`,
                    id: item_2.id,
                    label: `${item_2.name} - ${item_2.alias} - ${item_2.code}`
                  });

                  if (!all_facilities.includes(item_2.id)) {
                    all_facilities.push(item_2.id);
                  }

                });

                item_to_add.options = facilities;
                all_facilities_group.push(item_to_add);
              }

            });

            if (codes.length > 0) {

              let has_requisitions = false;
              let counter_list = Object.entries(response['counter']);

              (counter_list || []).map( item => {
                if (item[1]['1'] > 0 || item[1]['2'] > 0 || item[1]['3'] > 0 || item[1]['4'] > 0 || item[1]['5'] > 0 || item[1]['6'] > 0 || item[1]['7'] > 0 || item[1]['8'] > 0 || item[1]['9'] > 0 || item[1]['10'] > 0 || item[1]['11'] > 0 || item[1]['12'] > 0) {
                  has_requisitions = true;
                }
              });

              if (has_requisitions) {

                this.props.history.push(
                  `/company/controls/requisitionorders/?facilities=${all_facilities}&codes=${codes}`, {
                    transactionType: this.state.second_tab_selected !== 4 ? this.state.second_tab_selected : null, 
                  }
                );

              } else {

                this.setState({
                  error_message: 'Órdenes no encontradas'
                });
              }

            } else {

              this.setState({
                facilityCatalog: all_facilities_group,
                ordersResume: Object.entries(response['data']),
                ordersResumeCounter: response['counter']
              });
            }

          }

        })
      break;
      case 4:
        this.props.loadCompanyTripsResume({
          company_id: this.props.companyId,
          trip_codes: codes
        }, {
          onSuccess: (response) => {

            let tags = Object.entries(response['data'] || {});
            let all_facilities_group = [];
            let all_facilities = [];

            tags.map( item => {

              if (item.length > 1) {

                let item_to_add = {
                  label: `${item[0]}` === 'null' ? 'Sin tag' : item[0]
                }
                let facilities = [];

                (item[1] || []).map( item_2 => {
                  facilities.push({
                    value: `${item_2.id}`,
                    id: item_2.id,
                    label: `${item_2.name} - ${item_2.alias} - ${item_2.code}`
                  });

                  if (!all_facilities.includes(item_2.id)) {
                    all_facilities.push(item_2.id);
                  }

                });

                item_to_add.options = facilities;
                all_facilities_group.push(item_to_add);
              }

            });

            if (codes.length > 0) {

              let has_requisitions = false;
              let counter_list = Object.entries(response['counter']);

              (counter_list || []).map( item => {
                if (item[1]['1'] > 0 || item[1]['2'] > 0 || item[1]['3'] > 0 || item[1]['4'] > 0 || item[1]['5'] > 0 || item[1]['6'] > 0 || item[1]['7'] > 0 || item[1]['8'] > 0 || item[1]['9'] > 0 || item[1]['10'] > 0 || item[1]['11'] > 0) {
                  has_requisitions = true;
                }
              });

              if (has_requisitions) {

                this.props.history.push(
                  `/company/controls/trips/?facilities=${all_facilities}&codes=${codes}`, {
                    transactionType: this.state.second_tab_selected !== 4 ? this.state.second_tab_selected : null, 
                  }
                );

              } else {

                this.setState({
                  error_message: 'Viajes no encontrados'
                });
              }

            } else {

              this.setState({
                facilityCatalog: all_facilities_group,
                tripsResume: Object.entries(response['data']),
                tripsResumeCounter: response['counter']
              });

            }

          }

        });
      break;
      case 5:
        this.props.loadCompanyTrTripsResume({
          company_id: this.props.companyId,
          trip_codes: codes
        }, {
          onSuccess: (response) => {

            let tags = Object.entries(response['data'] || {});
            let all_fleet_providers = [];
            
            tags.map( item => {
              if (item.length > 1) {
                if (!all_fleet_providers.includes(item[1]['fleet_provider'])) {
                  all_fleet_providers.push(item[1]['fleet_provider']);
                }
              }
            });

            if (codes.length > 0) {

              let has_requisitions = false;
              let counter_list = Object.entries(response['counter']);

              (counter_list || []).map( item => {
                if (item[1]['1'] > 0 || item[1]['2'] > 0 || item[1]['3'] > 0 || item[1]['4'] > 0 || item[1]['5'] > 0 || item[1]['6'] > 0 || item[1]['7'] > 0 || item[1]['8'] > 0 || item[1]['9'] > 0 || item[1]['10'] > 0 || item[1]['11'] > 0) {
                  has_requisitions = true;
                }
              });

              if (has_requisitions) {

                this.props.history.push(
                  `company/controls/shipments/?fleet_provider=${all_fleet_providers}&codes=${codes}`
                );

              } else {

                this.setState({
                  error_message: 'Viajes no encontrados'
                });
              }

            } else {

              this.setState({
                trTripsResume: Object.entries(response['data']),
                trTripsResumeCounter: response['counter']
              });

            }

          }

        });
      break;
      default:
    }
  }

  buildEmptySpace = () => {

    if (this.props.isLoading) {
      return '';
    }

    if (
      (this.state.tab_selected === 1 && this.state.requisitionsResume.length === 0) ||
      (this.state.tab_selected === 3 && this.state.ordersResume.length === 0) ||
      (this.state.tab_selected === 4 && this.state.tripsResume.length === 0) ||
      (this.state.tab_selected === 5 && this.state.trTripsResume.length === 0)
    ) {
      return(
        <NoResultsStyled>
          No se encontró ningún dato
          <LoadContentStyled>
            <Button
              settings={{
                type: "btn primary small",
                text: "Cargar",
                onClick: () => this.loadItems(),
              }}
            />
          </LoadContentStyled>
        </NoResultsStyled>
      );
    }

    return '';

  }

  filterRequisitionResume = () => {

    let counter = {
      purchase: {
        "1": 0,
        "2": 0
      },
      sales: {
        "1": 0,
        "2": 0
      },
      all: {
        "1": 0,
        "2": 0
      }
    };

    let tags = this.state.requisitionsResume;
    let all_facilities_group = [];

    tags.map( item => {

      if (item.length > 1) {

        let facilities = [];

        (item[1] || []).map( item_2 => {

          if (this.state.searchStr === '') {
            facilities.push(item_2);

            // if (this.state.second_tab_selected === 1) {
            //   let value_1 = item_2.purchase_requisitions['1']
            //   let value_2 = item_2.purchase_requisitions['2']

            //   counter['purchase']['1'] += value_1;
            //   counter['purchase']['2'] += value_2;
            // } else if (this.state.second_tab_selected === 2) {
            //   let value_1 = item_2.sales_requisitions['1']
            //   let value_2 = item_2.sales_requisitions['2']

            //   counter['sales']['1'] += value_1;
            //   counter['sales']['2'] += value_2;
            // }

          } else {
            if (`${item_2.name} - ${item_2.alias} - ${item_2.code}`.toLowerCase().includes(this.state.searchStr.toLowerCase())) {
              facilities.push(item_2);

              // if (this.state.second_tab_selected === 1) {
              //   let value_1 = item_2.purchase_requisitions['1']
              //   let value_2 = item_2.purchase_requisitions['2']
  
              //   counter['purchase']['1'] += value_1;
              //   counter['purchase']['2'] += value_2;
              // } else if (this.state.second_tab_selected === 2) {
              //   let value_1 = item_2.sales_requisitions['1']
              //   let value_2 = item_2.sales_requisitions['2']
  
              //   counter['sales']['1'] += value_1;
              //   counter['sales']['2'] += value_2;
              // }
            }
          }

        });

        if (facilities.length > 0) {
          all_facilities_group.push([item[0], facilities])
        }

      }

    });

    return {facilities: all_facilities_group, count: this.props.requisitionsResumeCounter || {}}

  }

  filterOrderResume = () => {
    let counter = {
      purchase: {
        "1": 0, "2": 0, "3": 0, "4": 0, "5": 0, "6": 0, "7": 0, "8": 0, "9": 0, "10": 0, "11": 0, "12": 0
      },
      sales: {
        "1": 0, "2": 0, "3": 0, "4": 0, "5": 0, "6": 0, "7": 0, "8": 0, "9": 0, "10": 0, "11": 0, "12": 0
      },
      all: {
        "1": 0, "2": 0, "3": 0, "4": 0, "5": 0, "6": 0, "7": 0, "8": 0, "9": 0, "10": 0, "11": 0, "12": 0
      }
    };

    let tags = this.state.ordersResume;
    let all_facilities_group = [];

    tags.map( item => {

      if (item.length > 1) {

        let facilities = [];

        (item[1] || []).map( item_2 => {

          if (this.state.searchStr === '') {
            facilities.push(item_2);

            // if (this.state.second_tab_selected === 1) {

            //   counter['purchase']['1'] += item_2.purchase_orders['1'];
            //   counter['purchase']['2'] += item_2.purchase_orders['2'];
            //   counter['purchase']['3'] += item_2.purchase_orders['3'];
            //   counter['purchase']['4'] += item_2.purchase_orders['4'];
            //   counter['purchase']['5'] += item_2.purchase_orders['5'];
            //   counter['purchase']['6'] += item_2.purchase_orders['6'];
            //   counter['purchase']['7'] += item_2.purchase_orders['7'];
            //   counter['purchase']['8'] += item_2.purchase_orders['8'];
            //   counter['purchase']['9'] += item_2.purchase_orders['9'];
            //   counter['purchase']['10'] += item_2.purchase_orders['10'];
            //   counter['purchase']['11'] += item_2.purchase_orders['11'];
            //   counter['purchase']['12'] += item_2.purchase_orders['12'];

            // } else if (this.state.second_tab_selected === 2) {

            //   counter['sales']['1'] += item_2.sales_orders['1'];
            //   counter['sales']['2'] += item_2.sales_orders['2'];
            //   counter['sales']['3'] += item_2.sales_orders['3'];
            //   counter['sales']['4'] += item_2.sales_orders['4'];
            //   counter['sales']['5'] += item_2.sales_orders['5'];
            //   counter['sales']['6'] += item_2.sales_orders['6'];
            //   counter['sales']['7'] += item_2.sales_orders['7'];
            //   counter['sales']['8'] += item_2.sales_orders['8'];
            //   counter['sales']['9'] += item_2.sales_orders['9'];
            //   counter['sales']['10'] += item_2.sales_orders['10'];
            //   counter['sales']['11'] += item_2.sales_orders['11'];
            //   counter['sales']['12'] += item_2.sales_orders['12'];

            // }

          } else {
            if (`${item_2.name} - ${item_2.alias} - ${item_2.code}`.toLowerCase().includes(this.state.searchStr.toLowerCase())) {
              facilities.push(item_2);

              // if (this.state.second_tab_selected === 1) {
                
              //   counter['purchase']['1'] += item_2.purchase_orders['1'];
              //   counter['purchase']['2'] += item_2.purchase_orders['2'];
              //   counter['purchase']['3'] += item_2.purchase_orders['3'];
              //   counter['purchase']['4'] += item_2.purchase_orders['4'];
              //   counter['purchase']['5'] += item_2.purchase_orders['5'];
              //   counter['purchase']['6'] += item_2.purchase_orders['6'];
              //   counter['purchase']['7'] += item_2.purchase_orders['7'];
              //   counter['purchase']['8'] += item_2.purchase_orders['8'];
              //   counter['purchase']['9'] += item_2.purchase_orders['9'];
              //   counter['purchase']['10'] += item_2.purchase_orders['10'];
              //   counter['purchase']['11'] += item_2.purchase_orders['11'];
              //   counter['purchase']['12'] += item_2.purchase_orders['12'];

              // } else if (this.state.second_tab_selected === 2) {
                
              //   counter['sales']['1'] += item_2.sales_orders['1'];
              //   counter['sales']['2'] += item_2.sales_orders['2'];
              //   counter['sales']['3'] += item_2.sales_orders['3'];
              //   counter['sales']['4'] += item_2.sales_orders['4'];
              //   counter['sales']['5'] += item_2.sales_orders['5'];
              //   counter['sales']['6'] += item_2.sales_orders['6'];
              //   counter['sales']['7'] += item_2.sales_orders['7'];
              //   counter['sales']['8'] += item_2.sales_orders['8'];
              //   counter['sales']['9'] += item_2.sales_orders['9'];
              //   counter['sales']['10'] += item_2.sales_orders['10'];
              //   counter['sales']['11'] += item_2.sales_orders['11'];
              //   counter['sales']['12'] += item_2.sales_orders['12'];

              // }
            }
          }

        });

        if (facilities.length > 0) {
          all_facilities_group.push([item[0], facilities])
        }

      }

    });

    return {facilities: all_facilities_group, count: this.props.ordersResumeCounter}
  }

  getResume = () => {
    if (this.state.tab_selected === 1) { 
      return this.filterRequisitionResume().facilities;
    }

    if (this.state.tab_selected === 3) {
      return this.filterOrderResume().facilities;
    }

    if (this.state.tab_selected === 4) {
      return this.state.tripsResume;
    }

    if (this.state.tab_selected === 5) {
      return this.state.trTripsResume;
    }

    return [];
  }

  getResumeCounter = () => {
    if (this.state.tab_selected === 1) {
      return this.filterRequisitionResume().count;
    }

    if (this.state.tab_selected === 3) {
      return this.filterOrderResume().count;
    }

    if (this.state.tab_selected === 4) {
      return this.state.tripsResumeCounter;
    }

    if (this.state.tab_selected === 5) {
      return this.state.trTripsResumeCounter;
    }

    return {};
  }

  resetModal = () => {
    this.setState({
      productsToAdd: [],
      selectedProvider: 0,
      selectedFacility: 0,
      selectedTags: [],
      selectedOrdersId: [],
      selectedCode: "",
      selectedDate: null,
      selectedLevel: 1,
      selectedClass: 0,
      selectedDestiny: null,
      providerProducts: [],
      providerFacilities: [],
      selectedClient: null
    })
  }

  handleModalChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    switch(name){
      case 'selectedCode':
        this.setState({[name]: value.replace(/\s/g, '')});
        break;
      case 'selectedClient':
        this.setState({[name]: value});
        break;
      case 'selectedFacility':
        this.state.selectedDestiny = null;
        this.setState({[name]: value});
      break;
      case "validateCode":
        let found_callback = value.found_callback || null;
        let no_found_callback = value.no_found_callback || null;

        let from_company_info = (this.props.companyProviders || []).find(fC => fC.value === this.state.selectedProvider);

        this.props.validateCode({
          company_id: this.props.companyId,
          view: 'validate',
          code: this.state.selectedCode,
          from_company_id: from_company_info.id || 0,
          to_company_id: this.props.companyType === 3 ? this.state.selectedClient : this.props.companyId
        }, {
          onSuccess: (response) => {

            if ('is_found' in response && response.is_found && found_callback) {
              found_callback()
            } else {
              if (no_found_callback) no_found_callback();
            }

          }
        });
      break;
      case "searchProduct":
        let search_value = value.search_value || '';
        let offset = value.offset || '';

        this.props.cancelMultipleRequests();
        this.loadProviderProducts(search_value, offset);
        break;
      case "selectedDestiny":
        this.setState({
          selectedDestiny: value
        });
        break;
      case "selectedProvider": 
        this.setState({
          selectedProvider: value, 
          selectedFacility: 0,
          selectedDestiny: null,
          providerProducts: [],
          productsToAdd: []
        }, () => {
          this.loadProviderFacilities();
          this.loadProviderProducts('','');
        });
        break;
      // case "addProduct":
      //   this.setState({productsToAdd: this.state.productsToAdd.concat([{id: value.id, qty: value.qty}])})
      //   break;
      case "updateProduct":
        let products = this.state.productsToAdd.filter(p => p.id !== value.id);
        // let index = this.state.productsToAdd.map(p => p.id).indexOf(value.id);
        // let selectedProduct = products.splice(index,1)[0];
        if(value.qty){
          products.push({
            id: value.id,
            qty: value.qty,
            gross_weight: value.gross_weight || 0,
            gross_weight_description: value.gross_weight_description || '',
            net_weight: value.net_weight || 0, 
            net_weight_description: value.net_weight_description || '',
            volume: value.volume || 0,
            volume_description: value.volume_description || '',
            qty_per_sku: value.qty,
            product_unit_description: value.product_unit_description || '',
            data: value.data || {},
            product: value.product
          })
        }
        this.setState({productsToAdd: products});
        break;
      case "removeProduct":
        let products1 = this.state.productsToAdd.filter(p => p.id !== value);
        // let index = this.state.productsToAdd.map(p => p.id).indexOf(value.id);
        // let selectedProduct = products.splice(index,1)[0];
        this.setState({productsToAdd: products1});
        break;
      
      case "createOrder":
        let reqProducts = [];
        this.state.productsToAdd.forEach(p => {
          let qty = Number(p.qty);
          reqProducts.push({id: p.id, qty})
        });

        let delivery_date = null;
        
        if (this.state.selectedDate !== null && this.state.selectedDate !== '') {
          delivery_date = moment(this.state.selectedDate, "MM/DD/YYYY").format('YYYY-MM-DD');
        }

        let from_company = (this.props.companyProviders || []).find(fC => fC.value === this.state.selectedProvider);

        this.props.createRequisitionV2({
          company_id: this.props.companyId,
          products: reqProducts,
          from_facility: Number(this.state.selectedFacility),
          to_facility: Number(this.state.selectedDestiny),
          code: this.state.selectedCode,
          network_id: this.state.selectedProvider !== '-1' ? Number(this.state.selectedProvider) : null,
          delivery_date,
          from_company_id: from_company.id || 0,
          to_company_id: this.props.companyType === 3 ? this.state.selectedClient : this.props.companyId,
          last_facility: Number(this.state.selectedDestiny)
        }, {
          onSuccess: (result) => {
            value();
            this.loadItems();

            showSimpleFlashNotification('Se creó con éxito el pedido', null);

            try {
              sendMessageToMultipleUsersInSocket(
                this.props.userId,
                result['users'],
                result['data']
              );
            } catch(e) {
              console.log('requisition creation error:', e)
            }

          },
          onError: (e) => {
            value();
            this.setState({
              error_message: e.response?.data?.error || 'Ocurrío un error, intente de nuevo'
            })
          }
        });
        break;
      default:
        this.setState({[name]: value});
    }
  }

  getTabs = () => { 
    if (!this.props.isCOWH) {
      return(
        <div 
          className={`tab ${this.state.tab_selected === 5 ? 'selected' : ''}`}
          onClick={() => {
            if (this.state.tab_selected !== 5) {
              this.setState({tab_selected: 5}, () => this.loadItems())
            }
          }}
        >Embarques</div>
      );
    }

    if (this.state.tabSelectedByMenu === 'pedidos') {
      return(
        <div 
          className={`tab ${this.state.tab_selected === 1 ? 'selected' : ''}`}
          onClick={() => {
            if (this.state.tab_selected !== 1) {
              this.setState({tab_selected: 1, searchStr: '', emails: [], searchStr2: ''}, () => this.loadItems())
            }
          }}
        >Pedidos</div>
      );
    } else if (this.state.tabSelectedByMenu === 'ordenes') {
      return(
        <div 
          className={`tab ${this.state.tab_selected === 3 ? 'selected' : ''}`}
          onClick={() => {
            if (this.state.tab_selected !== 3) {
              this.setState({tab_selected: 3, searchStr: '', emails: [], searchStr2: ''}, () => this.loadItems())
            }
          }}
        >Órdenes</div>
      );
    } else {
      return(
        <>
          <div 
            className={`tab ${this.state.tab_selected === 1 ? 'selected' : ''}`}
            onClick={() => {
              if (this.state.tab_selected !== 1) {
                this.setState({tab_selected: 1, searchStr: '', emails: [], searchStr2: ''}, () => this.loadItems())
              }
            }}
          >Pedidos</div>

          <div 
            className={`tab ${this.state.tab_selected === 3 ? 'selected' : ''}`}
            onClick={() => {
              if (this.state.tab_selected !== 3) {
                this.setState({tab_selected: 3, searchStr: '', emails: [], searchStr2: ''}, () => this.loadItems())
              }
            }}
          >Órdenes</div>

          <div 
            className={`tab ${this.state.tab_selected === 4 ? 'selected' : ''}`}
            onClick={() => {
              if (this.state.tab_selected !== 4) {
                this.setState({tab_selected: 4}, () => this.loadItems())
              }
            }}
          >Embarques</div>
        </>
      );
    }

  }

  manageFilterSearch = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "searchStr":
        this.setState({ searchStr: value }, () => {});
        break;
      case "doSearch":
        this.setState({ offset: 1 }, () => {});
        break;
      default:
    }
  };

  handleEmailInput = (e) => {
    if (e) {
      switch (e.target.name) {
        case "inviteTags":
          let mails = e.target.value
            .map((i) => ({
              email: i.email,
              avatar: "hide",
              avatarType: "",
              userId: null,
            }));
          this.setState({ 
            emails: mails, 
            searchStr2: e.target.value.map(e => e.email), 
            offset: 1,
            buttonFilterName: "Aplicar"
          }, () => {
            this.loadItems()
          });
          break;
        case "deleteTags":
          this.setState({ emails: [].concat(e.target.value), searchStr2: e.target.value.map(e => e.email), offset: 1 }, () => {
            this.loadItems()
          });
          break;
        default:
      }
    }
  };

  getTitleSearch = () => {
    return this.state.second_tab_selected === 1 ? 'compra' : 'venta';
  }

  render() {

    return(
      <View className="orders-control-view">
        <div
          style={{
            display: 'flex',
            marginRight: 60,
            flexDirection: 'row-reverse',
            marginBottom: 15
          }}
        >
          <HelperFilesModal
            files={[]}
          />
        </div>

        {
          (this.props.isLoading) && 
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              backgroundColor: "#00000080",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1001,
              backdropFilter: "blur(3px)"
            }}
          >
            <div style={{display: "flex", alignItems: "center"}}>
              <Loader width="100px" height="100px"/>
              <div style={{color: "#fff", fontSize: "36px"}}>
                Cargando
              </div>
            </div>
            <div style={{color: "#fff", fontSize: "30px"}}>
              Si desea cancelar la consulta, presione ESC
            </div>
          </div>
        }
        
        <TabContainer>

          { this.getTabs() }

        </TabContainer>

        <div className="switches-container">

          {
            ([1,3].includes(this.state.tab_selected)) ?
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  marginBottom: 30
                }}
              >
                <FilterBarCompact
                  searchOnly={true}
                  searchStr={this.state.searchStr}
                  searchAction={this.manageFilterSearch}
                />
              </div> : <div/>
            }

          <div style={{marginTop: [1,3].includes(this.state.tab_selected) ? 25 : 0}}>
            {
              [4,5].includes(this.state.tab_selected) ?
                <OptionSelectorSwitch
                  value={this.state.third_tab_selected}
                  name="third_tab_selected"
                  onChange={this.handleChange}
                  items={ITEMS}
                /> : ![4,5].includes(this.state.tab_selected) ?
                <OptionSelectorSwitch
                  value={this.state.second_tab_selected}
                  name="second_tab_selected"
                  onChange={this.handleChange}
                  items={TRANSACTIONS}
                /> : <div/>
            }
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              marginBottom: 30
            }}
          >
            {
              [1,3,4,5].includes(this.state.tab_selected) ?
              <FilterBarCompact
                searchOnly={true}
                limit={350}
                multiText={true}
                searchStr={this.state.emails} 
                searchPlaceholder={this.state.tab_selected === 1 ? `Busca pedido(s) de ${this.getTitleSearch()}` : this.state.tab_selected === 3 ? `Busca orden(es) de ${this.getTitleSearch()}` : 'Busca embarque(s)'}
                clearMultiText={() => this.setState({ emails: [] })}
                searchAction={this.handleEmailInput}
                filterAction={() => {}}
                buttonFilterName={''}
                onChange={(e) => {}}
                selectedItems={{}}
              /> : <div style={{height: 32}}/>
            }
          </div>

        </div>

        
        {/* <div
          style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}
        >
          <div style={{width: 350}}>
            {
              (this.state.tab_selected === 4 || this.state.tab_selected === 5) ?
              <OptionSelectorSwitch
                value={this.state.third_tab_selected}
                name="third_tab_selected"
                onChange={this.handleChange}
                items={ITEMS}
              /> : <div/>
            }
          </div>
          
          <div style={{width: '30%'}}>
            {
              ![4,5].includes(this.state.tab_selected) ?
              <OptionSelectorSwitch
                value={this.state.second_tab_selected}
                name="second_tab_selected"
                onChange={this.handleChange}
                items={TRANSACTIONS}
              /> : <div/>
            }
          </div>

          <div/>
          
        </div> */}
        
        {/* <div
          style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: -32}}
        >
          <div/>
          <div/>

          {
            [1,3,4,5].includes(this.state.tab_selected) ?
            <FilterBarCompact
              searchOnly={true}
              limit={350}
              multiText={true}
              searchStr={this.state.emails} 
              searchPlaceholder={this.state.tab_selected === 1 ? `Busca pedido(s) de ${this.getTitleSearch()}` : this.state.tab_selected === 3 ? `Busca orden(es) de ${this.getTitleSearch()}` : 'Busca embarque(s)'}
              clearMultiText={() => this.setState({ emails: [] })}
              searchAction={this.handleEmailInput}
              filterAction={() => {}}
              buttonFilterName={''}
              onChange={(e) => {}}
              selectedItems={{}}
            /> : <div style={{height: 32}}/>
          }

        </div> */}

        <div style={{height: 10, marginTop: [1,3].includes(this.state.tab_selected) ? -30 : -10}}/>

        <Flex>
          <div>
            {/* {
              ([1,3].includes(this.state.tab_selected)) &&
              <FilterBarCompact
                searchOnly={true}
                searchStr={this.state.searchStr}
                searchAction={this.manageFilterSearch}
              />
            } */}
          </div>
          <div/>
          
          <div style={{ width: (this.state.tab_selected === 1 && [1,4].includes(this.state.second_tab_selected)) ? "400px" : "200px", marginLeft: "auto", marginRight: "0", display: 'flex', alignItems: 'center' }}>
            <Button 
              key={'btn-to-invite-companies'} 
              settings={{
                type: 'btn secondary',
                text: 
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingLeft: 10,
                      paddingRight: 10
                    }}
                  > 
                    <img
                      alt=""
                      src="/images/invite_company.png"
                      style={{width: 20, height: 20, marginRight: 10, filter: 'invert(1)'}}
                    />
                    {"Invitar Empresas"}
                  </div>,
                onClick: () => this.props.history.push('/company/network?inviteModal=true')
              }}
            />
            {
              (this.state.tab_selected === 1 && [1,4].includes(this.state.second_tab_selected)) && 
              <>
                <div style={{width: 10}}/>
                <Button
                  settings={{
                    disabled: ![1,4].includes(this.state.second_tab_selected),
                    type: "primary",
                    text: 'Crear Pedido de Compra',
                    onClick: () => this.setState({showCreateOrderModal: true})
                  }}
                />
              </>
            }
          </div>

        </Flex>
        
        <div className="content"> 
          <OrdersSummaryList
            simpleRow={this.state.tab_selected === 5}
            disabled={!this.props.isCOWH}
            history={this.props.history}
            ordersResume={this.getResume()}
            itemType={this.state.tab_selected}
            transactionType={this.state.tab_selected === 5 ? 4 :this.state.second_tab_selected}
            transportType={this.state.third_tab_selected}
            columnCounter={this.getResumeCounter()}
          />
        </div>

        { this.buildEmptySpace() }

        {
          this.state.showCreateOrderModal &&
          <CreateOrderModal
            show={this.state.showCreateOrderModal}
            onClose={() => {this.resetModal(); this.setState({showCreateOrderModal: false})}}
            handleChange={this.handleModalChange}

            selectedProducts={this.state.productsToAdd}
            selectedProvider={this.state.selectedProvider}
            selectedFacility={this.state.selectedFacility}
            selectedTags={this.state.selectedTags}
            selectedCode={this.state.selectedCode}
            selectedDestiny={this.state.selectedDestiny}

            productCatalog={this.state.providerProducts}
            providerCatalog={this.props.companyProviders}
            facilitiesCatalog={
              this.state.selectedProvider === '-1' ? this.state.facilityCatalog : this.state.providerFacilities
            }
            tagsCatalog={[]}
            unitsCatalog={this.props.companyUnits}

            facilitiesDestiny={this.state.facilityCatalog}
            isLoadingProducts={this.props.isLoadingProducts}
            moreProducts={this.state.moreProducts}
            isValidationLoading={this.props.isValidationLoading}
            isCreationLoading={this.props.isRequisitionCreationLoading}
            selectedDate={this.state.selectedDate}
            clients={this.props.clients}
            companyType={this.props.companyType}
            selectedClient={this.props.companyType === 3 ? this.state.selectedClient : this.props.companyId}
          />
        }

        {
          this.state.error_message &&
          <GenericDialog
            open={this.state.error_message !== null}
            title={'Error'}
            message={this.state.error_message}
            acceptAction={() => this.setState({error_message: null})}
            closeAction={() => this.setState({error_message: null})}
          />
        }
        
      </View>
    );

  }
}

const mapStateToProps = (state) => {
  const companyType = state?.globalCatalog?.session?.company?.type?.id || 0;
  const companyId = state?.globalCatalog?.session?.company?.id || -1; 
  const ordersResume = Object.entries(getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.ORDERS.RESUME")['data'] || {});
  const tripsResume = Object.entries(getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUME")['data'] || {});
  const requisitionsResume = Object.entries(getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.RESUME")['data'] || {});
  const trTripsResume = Object.entries(getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUMETR")['data'] || {});
  const requisitionsResumeCounter = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.RESUME")['counter'] || {};
  const ordersResumeCounter = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.ORDERS.RESUME")['counter'] || {};
  const tripsResumeCounter = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUME")['counter'] || {};
  const isOrdersLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.ORDERS.RESUME']?.status?.isFetching || false;
  const isTripsLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUME']?.status?.isFetching || false;
  const isTrTripsLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUMETR']?.status?.isFetching || false;
  const isRequisitionLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.RESUME']?.status?.isFetching || false;
  const isRequisitionCreationLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.CREATIONV2']?.status?.isFetching || false;
  const trTripsResumeCounter = getEntityItems(state, "COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUMETR")['counter'] || {};
  const ownProducts = getEntityItems(state, "COMPANIES.PRODUCTS") || [];
  const isOwnProductsLoading = state?.api['COMPANIES.PRODUCTS']?.status?.isFetching || false;
  const isProductsLoading = state?.api['COMPANIES.ORDERS.CONTROL.PROVIDERS.PRODUCTSPARAMS']?.status?.isFetching || false;
  const isSignatureValidationLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.TRIPS.VALIDATESIGNATURE']?.status?.isFetching || false;
  const isCodeValidationLoading = state?.api['COMPANIES.REQUISITIONSCONTROL.ORDERS.VALIDATEREQUISITION']?.status?.isFetching || false;
  const facilityData = getEntityItems(state, "COMPANIES.FACILITIES"); 
  const companyUnits = getEntityItems(state, "COMPANIES.CATALOGS.UNITS");
  const providerProducts = getEntityItems(state, "COMPANIES.ORDERS.CONTROL.PROVIDERS.PRODUCTSPARAMS");
  let companyProviders = getEntityItems(state, "COMPANIES.ORDERS.CONTROL.PROVIDERS").reduce(
    (result, network) => {
      // let id = companyProviders.find(
      //   (provider) => provider.id === network.id
      // );
      if (network.from_companies.id === companyId) {
        if (network.to_companies.type === 2) {
          result.push({
            value: String(network.id),

            label: network.to_companies_alias.concat(
              " - ",
              network.to_companies_code,
              " - ",
              network.to_companies.orbi_id
            ),
            id: network.to_companies.id
          });
        }
      } else {
        if (network.from_companies.type === 2)
          result.push({
            // value: network.id,
            value: String(network.id),
            // label: network.from_companies.corporation_name,
            label: network.from_companies.orbi_id.concat(
              " - ",
              network.from_companies_alias,
              " - ",
              network.from_companies_code
            ),
            id: network.from_companies.id
          });
      }
      return result;
    },
    []
  ) || [];

  let clients = companyType === 3 ? cloneDeep(companyProviders) : [
    {
      value: state?.globalCatalog?.session?.company?.id || -1,
      label: `${state?.globalCatalog?.session?.company?.orbi_id || ''}`,
      id: state?.globalCatalog?.session?.company?.id || -1
    }
  ];

  if (companyType !== 3) {
    companyProviders.unshift(
      {
        value: '-1', // -1 se interpreta como propia
        label: `${state?.globalCatalog?.session?.company?.orbi_id || ''}`,
        id: state?.globalCatalog?.session?.company?.id || -1
      }
    );
  }

  return {
    requisitionsResumeCounter,
    ordersResumeCounter,
    clients,
    companyType,
    companyId,
    // tripsResume,
    // ordersResume,
    // requisitionsResume,
    // requisitionsResumeCounter,
    // ordersResumeCounter,
    // tripsResumeCounter,
    isLoading: isRequisitionLoading || isOrdersLoading || isTripsLoading || isTrTripsLoading, 
    providerProducts,
    companyProviders,
    facilityData,
    companyUnits,
    // trTripsResumeCounter,
    // trTripsResume,
    ownProducts,
    isCOWH: [2,3].includes((state?.globalCatalog?.session?.company?.type?.id || 0)), // validate if the company type is warehouse or cargo owner
    isLoadingProducts: isOwnProductsLoading || isProductsLoading,
    isValidationLoading: isSignatureValidationLoading || isCodeValidationLoading,
    userId: state.globalCatalog.session.user.id,
    isRequisitionCreationLoading
  };
}

const mapDispatchToProps = (dispatch) => {
  dispatch(loadSession());
  dispatch(downloadPermissionFile());

  return {
    cancelMultipleRequests: () => dispatch(cancelMultipleRequests()),
    cancelRequest: (entityPath) => dispatch(cancelRequest(entityPath)),
    loadProducts: (params, opt) => dispatch( readEntities("COMPANIES.PRODUCTS", params, opt) ),
    loadCompanyTripsResume: (params, opt) =>
      dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUME", params, opt)),
    loadCompanyTrTripsResume: (params, opt) =>
      dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.TRIPS.RESUMETR", params, opt)),
    loadCompanyOrdersResume: (params, opt) =>
      dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.ORDERS.RESUME", params, opt)),
    loadCompanyRequisitionsResume: (params, opt) =>
      dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.RESUME", params, opt)),
    loadProviderFacilities: (params, opts) =>
      dispatch(readEntities("COMPANIES.ORDERS.CONTROL.PROVIDERS.FACILITIESTAGS", params, opts)),
    loadFacilityInfo: (params, opt) =>
      dispatch(readEntity("COMPANIES.FACILITIES", params, opt)),
    loadCompanyUnits: (params, opts) =>
      dispatch(readEntities("COMPANIES.CATALOGS.UNITS", params, opts)),
    loadProviderProducts: (params, opts) =>
      dispatch(readEntities("COMPANIES.ORDERS.CONTROL.PROVIDERS.PRODUCTSPARAMS", params, opts)),
    loadCompanyProviders: (params, opts) =>
      dispatch(readEntities("COMPANIES.ORDERS.CONTROL.PROVIDERS", params, opts)),
    createRequisition: (params, opts) =>
      dispatch(createEntity("COMPANIES.REQUISITIONSCONTROL.REQUISITIONS", params, opts)),
    createRequisitionV2: (params, opts) =>
      dispatch(createEntity("COMPANIES.REQUISITIONSCONTROL.REQUISITIONS.CREATIONV2", params, opts)),
    validateSignatureTrip: (params, opt) =>
      dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.TRIPS.VALIDATESIGNATURE", params, opt)),
    validateCode: (params, opt) =>
      dispatch(readEntities("COMPANIES.REQUISITIONSCONTROL.ORDERS.VALIDATEREQUISITION", params, opt)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeCoView));

const NoResultsStyled = styled.div`
  text-align: center;
  color: white;
  font-size: 35px;
  margin-top: 80px;
`;

const LoadContentStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 15px;
`;